import { doc, getDoc, setDoc } from 'firebase/firestore';
import type { Firestore } from 'firebase/firestore';
import type { Track } from '../types/Track';

const recentRef = (db: Firestore, uid: string) => doc(db, 'users', uid, 'data', 'recentlyPlayed');

type RecentDocument = { items?: Track[] };

export async function loadRecentlyPlayed(db: Firestore, uid: string): Promise<Track[]> {
  const snapshot = await getDoc(recentRef(db, uid));
  if (!snapshot.exists()) return [];
  const data = snapshot.data() as RecentDocument;
  return Array.isArray(data.items) ? data.items.slice(0, 12) : [];
}

function cleanForFirestore<T>(data: T): T {
  return JSON.parse(JSON.stringify(data));
}

export async function saveRecentlyPlayed(db: Firestore, uid: string, items: Track[]): Promise<void> {
  await setDoc(recentRef(db, uid), { items: cleanForFirestore(items.slice(0, 12)) }, { merge: true });
}

